import { createAPI } from '@/request.js'

// 代理列表
export const list = data => createAPI('/api/agent/staff/query.mt', 'post', data)
// 手机号码修改记录
export const cellphoneList = data => createAPI('/api/agent/staff/cellphone/modify/log.mt', 'post', data)
// 调整代理分润
export const profit = data => createAPI('/api/agent/staff/profit/modify.mt', 'post', data)
// 收益比例变更记录
export const profitList = data => createAPI('/api/agent/staff/profit/modify/log.mt', 'post', data)

// 钱包
export const wallet = data => createAPI('/api/staff/wallet/get.mt', 'post', data)
// 商家周收益
export const week = data => createAPI('/api/staff/week/profit.mt', 'post', data)
// 收益明细
export const statement = data => createAPI('/api/staff/statement/query.mt', 'post', data)
// 明细导出
export const excel = data => createAPI('/download/staff/statement/excel', 'get', data)
// 解除认证
export const cancelCredit = data => createAPI('/api/staff/credit/cancel.mt', 'post', data)
// 确认认证
export const confirmCredit = data => createAPI('/api/staff/credit/confirm.mt', 'post', data)
// 认证记录
export const creditList = data => createAPI('/api/staff/credit/modify/log.mt', 'post', data)
// 调整提现规则
export const withdraw = data => createAPI('/api/staff/withdraw/modify.mt', 'post', data)
